import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from './user.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // Fungsi untuk login
  login(credentials: { username: string; password: string }): Observable<any> {
    return this.http.post(`/api/login`, credentials, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    });
  }

  //Fungsi untuk ganti pass
  gantiPassword(data: {
    username: string;
    oldPassword: string;
    newPassword: string;
  }): Observable<any> {
    return this.http.post(`/api/ganti_pass`, data, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    });
  }

  //Fungsi untuk setting pengguna

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(`/api/pengguna`);
  }

  getUserById(id: number): Observable<User> {
    return this.http.get<User>(`/api/pengguna/${id}`);
  }

  createUser(user: User): Observable<User> {
    return this.http.post<User>(`/api/pengguna`, user);
  }

  updateUser(id: number, data: any): Observable<any> {
    return this.http.put(`/api/pengguna/${id}`, data);
  }

  deleteUser(id: number): Observable<any> {
    return this.http.delete<any>(`/api/pengguna/${id}`);
  }

  // Test email — send a verification mail from the admin panel
  sendTestEmail(toEmail: string): Observable<any> {
    return this.http.post(`/api/test-email`, { toEmail });
  }

  //-------------------------------------------------

  // Kapal
  getBoats(filters: any) {
    let params = new HttpParams().set(
      'trip_kategori',
      filters.trip_kategori || '',
    );
    params = params.set('include_hidden', 'true');
    return this.http.get<{ items: any[] }>(`/api/kapallite`, { params });
  }

  getBoatById(id: number): Observable<any> {
    return this.http.get(`/api/kapal/${id}`);
  }

  getBoatBySlug(slug: string, includeHidden: boolean = false): Observable<any> {
    const params = includeHidden
      ? new HttpParams().set('include_hidden', 'true')
      : undefined;
    return this.http.get(`/api/kapal/slug/${slug}`, { params });
  }

  createBoat(data: any): Observable<any> {
    return this.http.post(`/api/kapal`, data);
  }

  updateBoat(id: number, data: any): Observable<any> {
    return this.http.put(`/api/kapal/${id}`, data);
  }

  updateBoatBySlug(slug: string, data: any): Observable<any> {
    return this.http.put(`/api/kapal/slug/${slug}`, data);
  }

  deleteBoat(id: number): Observable<any> {
    return this.http.delete<any>(`/api/kapal/${id}`);
  }

  // Gambar Kapal
  getGambarKapalByKapalId(id_kapal: number): Observable<any> {
    return this.http.get(`/api/gambarkapal/${id_kapal}`);
  }

  createGambarKapal(data: any): Observable<any> {
    return this.http.post(`/api/gambarkapal`, data);
  }

  uploadGambarKapal(data: any): Observable<any> {
    return this.http.post(`/api/upload`, data);
  }

  deleteGambarKapal(id: number): Observable<any> {
    return this.http.delete<any>(`/api/l_admin/gambarkapal/${id}`);
  }

  // Keterangan
  getKeteranganByKapalId(id_kapal: number): Observable<any> {
    return this.http.get(`/api/keterangan/${id_kapal}`);
  }

  createKeterangan(data: any): Observable<any> {
    return this.http.post(`/api/keterangan`, data);
  }

  updateKeterangan(id: number, data: any): Observable<any> {
    return this.http.put(`/api/keterangan/${id}`, data);
  }

  // Tujuan
  getTujuanByKapalId(id_kapal: number): Observable<any> {
    return this.http.get(`/api/tujuan/${id_kapal}`);
  }

  createTujuan(data: any): Observable<any> {
    return this.http.post(`/api/tujuan`, data);
  }

  // Itinerary
  getItineraryByKapalId(id_kapal: number): Observable<any> {
    return this.http.get(`/api/itinerary/${id_kapal}`);
  }

  createItinerary(data: any): Observable<any> {
    return this.http.post(`/api/itinerary`, data);
  }

  updateItinerary(id: number, data: any): Observable<any> {
    return this.http.put(`/api/itinerary/${id}`, data);
  }

  deleteItinerary(id: number): Observable<any> {
    return this.http.delete(`/api/itinerary/${id}`);
  }

  // Price
  getPriceByKapalId(id_kapal: number): Observable<any> {
    return this.http.get(`/api/price/${id_kapal}`);
  }

  createPrice(data: any): Observable<any> {
    return this.http.post(`/api/price`, data);
  }

  updatePrice(id: number, data: any): Observable<any> {
    return this.http.put(`/api/price/${id}`, data);
  }

  deletePrice(id: number): Observable<any> {
    return this.http.delete(`/api/price/${id}`);
  }

  bulkDeletePrices(ids: number[]): Observable<any> {
    return this.http.delete(`/api/price`, { body: { ids } });
  }

  getLowestprice(id_kapal: number): Observable<any> {
    return this.http.get(`/api/harga_terkecil/${id_kapal}`);
  }

  // Services
  getServicesByKapalId(id_kapal: number): Observable<any> {
    return this.http.get(`/api/services/${id_kapal}`);
  }

  createServices(data: any): Observable<any> {
    return this.http.post(`/api/services`, data);
  }

  updateServices(id: number, data: any): Observable<any> {
    return this.http.put(`/api/services/${id}`, data);
  }

  deleteServices(id: number): Observable<any> {
    return this.http.delete(`/api/services/${id}`);
  }

  // Terms
  getTermsByKapalId(id_kapal: number): Observable<any> {
    return this.http.get(`/api/terms/${id_kapal}`);
  }

  createTerms(data: any): Observable<any> {
    return this.http.post(`/api/terms`, data);
  }

  updateTerms(id: number, data: any): Observable<any> {
    return this.http.put(`/api/terms/${id}`, data);
  }

  deleteTerms(id: number): Observable<any> {
    return this.http.delete(`/api/terms/${id}`);
  }

  // Articles
  getArticles(filters: { status?: string; q?: string } = {}): Observable<any> {
    let params = new HttpParams();
    if (filters.status) params = params.set('status', filters.status);
    if (filters.q) params = params.set('q', filters.q);
    return this.http.get(`/api/articles`, { params });
  }

  getArticle(id: number): Observable<any> {
    return this.http.get(`/api/articles/${id}`);
  }

  createArticle(data: FormData): Observable<any> {
    return this.http.post(`/api/articles`, data);
  }

  updateArticle(id: number, data: FormData): Observable<any> {
    return this.http.put(`/api/articles/${id}`, data);
  }

  deleteArticle(id: number): Observable<any> {
    return this.http.delete(`/api/articles/${id}`);
  }

  // Content Templates
  getContentTemplates(templateType?: string): Observable<any> {
    const params = templateType
      ? new HttpParams().set('template_type', templateType)
      : undefined;
    return this.http.get(`/api/content-templates`, { params });
  }

  createContentTemplate(data: any): Observable<any> {
    return this.http.post(`/api/content-templates`, data);
  }

  updateContentTemplate(id: number, data: any): Observable<any> {
    return this.http.put(`/api/content-templates/${id}`, data);
  }

  deleteContentTemplate(id: number): Observable<any> {
    return this.http.delete(`/api/content-templates/${id}`);
  }

  //Accomodation
  getAccommodations(params: any): Observable<any> {
    return this.http.get(this.baseUrl, { params });
  }

  createAccommodation(data: any): Observable<any> {
    return this.http.post(`/api/acc`, data);
  }

  updateAccommodation(id: number, data: any): Observable<any> {
    return this.http.put(`/api/acc/${id}`, data);
  }

  deleteAccommodation(id: number): Observable<any> {
    return this.http.delete(`/api/acc/${id}`);
  }

  // Schedule Cabin Availability
  getScheduleCabins(
    idKapal: number,
    dateFrom: string,
    dateTo: string,
  ): Observable<any> {
    let params = new HttpParams()
      .set('id_kapal', idKapal.toString())
      .set('date_from', dateFrom)
      .set('date_to', dateTo);
    return this.http.get(`/api/schedule-cabin`, { params });
  }

  /** Query cabin availability by boat ID + single date (hash-based lookup on backend) */
  getScheduleCabinsByDate(
    idKapal: number,
    date: string,
  ): Observable<any> {
    let params = new HttpParams()
      .set('id_kapal', idKapal.toString())
      .set('date', date);
    return this.http.get(`/api/schedule-cabin/by-date`, { params });
  }

  upsertScheduleCabin(data: any): Observable<any> {
    return this.http.put(`/api/schedule-cabin`, data);
  }

  getScheduleStatuses(
    boatIds: number[],
    month: number,
    year: number,
  ): Observable<any> {
    let params = new HttpParams()
      .set('boat_ids', boatIds.join(','))
      .set('month', month.toString())
      .set('year', year.toString());
    return this.http.get(`/api/schedule-status`, { params });
  }

  createSchedule(data: {
    id_kapal: number;
    date_from: string;
    date_to: string;
  }): Observable<any> {
    return this.http.post(`/api/schedule`, data);
  }

  deleteSchedule(id: number): Observable<any> {
    return this.http.delete(`/api/schedule/${id}`);
  }

  // Gambar Accomodation
  getGambarByAccId(id_acc: number): Observable<any> {
    return this.http.get(`/api/accimage/${id_acc}`);
  }

  createGambarAcc(data: any): Observable<any> {
    return this.http.post(`/api/accimage`, data);
  }

  uploadGambarAcc(data: any): Observable<any> {
    return this.http.post(`/api/uploadacc`, data);
  }

  deleteGambarAcc(id: number): Observable<any> {
    return this.http.delete<any>(`/api/l_admin/accimage/${id}`);
  }

  //Amenity Accomodation
  getAmenityByAccId(id_acc: number): Observable<any> {
    return this.http.get(`/api/acc/amenity/${id_acc}`);
  }

  createAmenityAcc(data: any): Observable<any> {
    return this.http.post(`/api/acc/amenity`, data);
  }

  updateAmenityAcc(id: number, data: any): Observable<any> {
    return this.http.post(`/api/acc/amenity/${id}`, data);
  }

  deleteAmenityAcc(id: number): Observable<any> {
    return this.http.delete<any>(`/api/acc/amenity/${id}`);
  }

  //Bed Accomodation
  getBedByAccId(id_acc: number): Observable<any> {
    return this.http.get(`/api/acc/bed/${id_acc}`);
  }

  createBedAcc(data: any): Observable<any> {
    return this.http.post(`/api/acc/bed`, data);
  }

  deleteBedAcc(id: number): Observable<any> {
    return this.http.delete<any>(`/api/acc/bed/${id}`);
  }

  //Pelanggan

  getPelanggan(): Observable<any> {
    return this.http.get<any>(`/api/pelanggan`);
  }

  deletePelanggan(id: number): Observable<any> {
    return this.http.delete<any>(`/api/pelanggan/${id}`);
  }

  //min tour
  saveMinimumNight(data: any) {
    return this.http.post(`/api/mintour`, data);
  }

  // updateMinimumNight(id: number, data: any) {
  //   return this.http.put(`/api/mintour/${id}`, data);
  // }

  getMinimumNightByKapal(id: number) {
    return this.http.get(`/api/mintour/${id}`);
  }
}
